import { useEffect, useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ViewTriggerIconGrid from "../../../../Assets/Icons/slider-horizontal.svg";
import EmptyStateImage from "../../../../Assets/Images/wedding couple.svg";
import EmptyStateImage2 from "../../../../Assets/Images/empty-state-2.svg";
import ViewTriggerIcon from "../../../../Assets/Icons/row-vertical.svg";
import { Search as SearchIcon } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import HomeTabs from "../HomeTabs";
import Content from "../Content";
import axiosInstance from "../../../../axiosInstance";
import NewWeddingModal from "../../../../Components/NewWeddingModal/NewWeddingModal";

const MyWeddings = (props) => {
  const [LeftTabSelected, setLeftTabSelected] = useState(true); // LeftTab refers to the all weddings tab
  const [PageItems, setPageItems] = useState([]);
  const [Favorites, setFavorites] = useState([]);
  const [SearchIsActive, setSearchIsActive] = useState(false);
  const [SearchKeyword, setSearchKeyword] = useState("");
  const [IsGridView, setIsGridView] = useState(false);
  const [InitialPageLoadIsDone, setInitialPageLoadIsDone] = useState(false);
  const [UserHasWeddings, setUserHasWeddings] = useState(false); // used for determining wether or not this user has created any weddings, to show the related empty state based on that.
  const [UserHasFavorites, setUserHasFavorites] = useState(false);
  const [newWeddingModalOpen, setNewWeddingModalOpen] = useState(false);

  useEffect(() => {
    fetchWeddings(true);
    fetchFavorites(true);
  }, []);

  const fetchWeddings = (IsInitialCall) => {
    var ReqURL =
      "/services/projectmanagement/api/projects?sort=lastModifiedDate,desc&page=0&size=1000";
    if (document.getElementById("search-input").value.length > 0) {
      ReqURL =
        "/services/projectmanagement/api/projects?sort=lastModifiedDate,desc&page=0&size=1000&&name.contains=" +
        document.getElementById("search-input").value;
    }
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        if (
          (Res.data.length > 0 && IsInitialCall) ||
          (document.getElementById("search-input").value.length > 0 &&
            Res.data.length === 0)
        ) {
          setUserHasWeddings(true);
        }

        if (
          document.getElementById("search-input").value.length === 0 &&
          Res.data.length === 0
        ) {
          setUserHasWeddings(false);
        }

        setPageItems(Res.data);

        if (IsInitialCall) {
          setInitialPageLoadIsDone(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchFavorites = (IsInitialCall) => {
    var ReqURL =
      "/services/projectmanagement/api/projects?favorite.equals=true&&sort=lastModifiedDate,desc&page=0&size=1000";
    if (document.getElementById("search-input").value.length > 0) {
      ReqURL =
        "/services/projectmanagement/api/projects?favorite.equals=true&&sort=lastModifiedDate,desc&&page=0&size=1000&name.contains=" +
        document.getElementById("search-input").value;
    }

    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        if (
          (Res.data.length > 0 && IsInitialCall) ||
          (document.getElementById("search-input").value.length > 0 &&
            Res.data.length === 0)
        ) {
          setUserHasFavorites(true);
        }
        if (
          document.getElementById("search-input").value.length === 0 &&
          Res.data.length === 0
        ) {
          setUserHasFavorites(false);
        }
        setFavorites(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleInputChange = (event) => {
    setSearchKeyword(event.target.value);
    if (event.target.value.length > 0) {
      setSearchIsActive(true);
      if (LeftTabSelected) {
        fetchWeddings();
      } else {
        fetchFavorites();
      }
    } else {
      if (SearchIsActive) {
        setSearchIsActive(false);
        if (LeftTabSelected) {
          fetchWeddings();
        } else {
          fetchFavorites();
        }
      }
    }
  };

  const clearSearch = () => {
    document.getElementById("search-input").value = "";
    setSearchIsActive(false);
    setSearchKeyword("");
    if (SearchIsActive && LeftTabSelected) {
      fetchWeddings();
    } else {
      fetchFavorites();
    }
  };

  const showPageContent = () => {
    if (InitialPageLoadIsDone) {
      if (LeftTabSelected && PageItems.length === 0) {
        return (
          <div className="empty-state">
            <p>
              {UserHasWeddings
                ? "No results found!"
                : "Create your first Dream Wedding!"}
            </p>
            <img
              alt=""
              src={UserHasWeddings ? EmptyStateImage2 : EmptyStateImage}
            />
          </div>
        );
      } else if (!LeftTabSelected && Favorites.length === 0) {
        return (
          <div className="empty-state">
            <p>
              {UserHasFavorites ? "No results found!" : "No favorites yet!"}
            </p>
            <img
              alt=""
              src={UserHasWeddings ? EmptyStateImage2 : EmptyStateImage}
            />
          </div>
        );
      } else {
        return (
          <>
            {!LeftTabSelected ? (
              <Content
                Items={Favorites}
                IsGridView={IsGridView}
                SearchKeyword={SearchKeyword}
                SearchIsActive={SearchIsActive}
                ClearSearch={() => clearSearch()}
                RefreshItems={() => fetchFavorites()}
                LeftTabSelected={LeftTabSelected}
                isMobileOrTablet={props.isMobileOrTablet}
              />
            ) : null}
            {LeftTabSelected ? (
              <Content
                Items={PageItems}
                IsGridView={IsGridView}
                SearchKeyword={SearchKeyword}
                SearchIsActive={SearchIsActive}
                ClearSearch={() => clearSearch()}
                RefreshItems={() => fetchWeddings()}
                LeftTabSelected={LeftTabSelected}
                isMobileOrTablet={props.isMobileOrTablet}
              />
            ) : null}
          </>
        );
      }
    }
  };

  const handleTabChange = (IsAllItems) => {
    setLeftTabSelected(IsAllItems);

    if (IsAllItems) {
      fetchWeddings();
    } else {
      fetchFavorites();
    }
  };

  return (
    <>
      <section className="search-bar">
        <TextField
          fullWidth
          variant="outlined"
          name="weddingly-search"
          autoComplete="off"
          id="search-input"
          placeholder="Search your creations..."
          value={SearchKeyword}
          onChange={handleInputChange}
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            width: "360px",
            height: "56px",
            "&:hover": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: "0", // Remove border on hover
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderWidth: "0", // Remove border on focus
            },
            "&:focus, &:active": {
              "& .MuiOutlinedInput-notchedOutline": {
                outline: "none", // Remove blue outline on focus and active
              },
            },
            "& .MuiOutlinedInput-input": {
              paddingLeft: "20px", // Adjust input right padding for search icon
            },
            "& .MuiInputAdornment-root": {
              position: "absolute",
              right: "8px", // Adjust position to the right
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton edge="start" aria-label="search">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </section>
      <section className="page-actions">
        <div
          className="view-trigger"
          onClick={() => setIsGridView(!IsGridView)}
        >
          <img
            alt=""
            src={IsGridView ? ViewTriggerIconGrid : ViewTriggerIcon}
            className={IsGridView ? "rotated" : ""}
          />
          <span style={{ color: "#171717" }}>
            {IsGridView ? "Grid view" : "List view"}
          </span>
        </div>
        <HomeTabs
          LeftTabSelected={LeftTabSelected}
          SetLeftTabSelected={(Bool) => handleTabChange(Bool)}
        />
        <div
          className="add-trigger"
          aria-label="Add wedding"
          role="button"
          onClick={() => setNewWeddingModalOpen(true)}
        >
          <AddIcon fontSize="15px" fontWeight={400} />
          <span>{props.isMobileOrTablet ? "Add wedding" : "NEW GALLERY"}</span>
        </div>
      </section>
      {showPageContent()}

      <NewWeddingModal
        open={newWeddingModalOpen}
        onClose={() => setNewWeddingModalOpen(false)}
      />
    </>
  );
};

export default MyWeddings;
